export const getQueryParameters = (queryParams?: { [key: string]: string | undefined }): string => {
  const queryStringParams = Object.entries(queryParams ?? {}).map(
    ([key, value]) => `${key}=${value ?? ''}`
  );

  return queryStringParams.length > 0 ? `?${queryStringParams.join('&')}` : '';
};
